import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';
import type { PrintCardColumnViewModel } from '../../../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import type { GlassHouseBrandGroupIndexCardStackContentViewModel } from '../../../../index-cards-3x5/glass-house-brand-group-index-card-stack-content/glass-house-brand-group-index-card-stack-content-view-model';

@Component({
  selector: 'app-glass-house-quantity-and-price',
  templateUrl: './glass-house-quantity-and-price.component.html',
  styleUrl: './glass-house-quantity-and-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseQuantityAndPriceComponent extends RenderContextComponent {
  @Input() data: GlassHouseBrandGroupCardData;
  @Input() parentViewModel: GlassHouseBrandGroupIndexCardStackContentViewModel;
  @Input() cappedSpoofedGridColViewModels: PrintCardColumnViewModel[];
  @Input() plusNMoreCols: number;
  setupViews() {}
  setupBindings() {}
}
